// Input 값 삭제 버튼
const handleValueDelete = (fieldName, formData, setFormData, Change) => {
    setFormData({
        ...formData,
        [fieldName]: '' // 전달된 필드명을 기준으로 해당 필드의 값을 비움
    });

};

// 연락처 포맷팅 함수 (백엔드 정규식과 일치)
const formatPhoneNumber = (value) => {
    if (!value) return '';

    // 숫자만 남기고 포맷팅
    const onlyNumbers = value.replace(/[^0-9]/g, '');
    let formattedPhone = onlyNumbers;

    if (onlyNumbers.startsWith('02')) {
        // 1. 지역번호가 두자리 (02)
        if (onlyNumbers.length === 9) {
            formattedPhone = onlyNumbers.replace(
                /(\d{2})(\d{3})(\d{4})/,
                '$1-$2-$3'
            ); // XX-XXX-XXXX
        } else if (onlyNumbers.length === 10) {
            formattedPhone = onlyNumbers.replace(
                /(\d{2})(\d{4})(\d{4})/,
                '$1-$2-$3'
            ); // XX-XXXX-XXXX
        }
    } else if (onlyNumbers.startsWith('010')) {
        // 2. 핸드폰 번호 (010)
        if (onlyNumbers.length === 10) {
            formattedPhone = onlyNumbers.replace(
                /(\d{3})(\d{3})(\d{4})/,
                '$1-$2-$3'
            ); // XXX-XXX-XXXX
        } else if (onlyNumbers.length === 11) {
            formattedPhone = onlyNumbers.replace(
                /(\d{3})(\d{4})(\d{4})/,
                '$1-$2-$3'
            ); // XXX-XXXX-XXXX
        }
    } else if (/^1[5-8]\d{2}/.test(onlyNumbers)) {
        // 3. 고객센터 번호 (1588, 1577, 1566 등)
        if (onlyNumbers.length === 8) {
            formattedPhone = onlyNumbers.replace(
                /(\d{4})(\d{4})/,
                '$1-$2'
            ); // XXXX-XXXX
        }
    } else if (/^0[3-6]\d/.test(onlyNumbers)) {
        // 4. 3자리 지역번호 (031, 032, 033, 041, 042, 043, 051, 052, 053, 054, 055, 061, 062, 063, 064)
        if (onlyNumbers.length === 10) {
            formattedPhone = onlyNumbers.replace(
                /(\d{3})(\d{3})(\d{4})/,
                '$1-$2-$3'
            ); // XXX-XXX-XXXX
        } else if (onlyNumbers.length === 11) {
            formattedPhone = onlyNumbers.replace(
                /(\d{3})(\d{4})(\d{4})/,
                '$1-$2-$3'
            ); // XXX-XXXX-XXXX
        }
    } else {
        // 5. 기타 일반 번호
        if (onlyNumbers.length === 10) {
            formattedPhone = onlyNumbers.replace(
                /(\d{3})(\d{3})(\d{4})/,
                '$1-$2-$3'
            ); // XXX-XXX-XXXX
        } else if (onlyNumbers.length === 11) {
            formattedPhone = onlyNumbers.replace(
                /(\d{3})(\d{4})(\d{4})/,
                '$1-$2-$3'
            ); // XXX-XXXX-XXXX
        }
    }

    return formattedPhone;
};

// 연락처 유효성 검사 함수
const validatePhoneNumber = (value) => {
    if (!value) return { isValid: false, error: '' };

    const originalNumbers = value.replace(/[^0-9]/g, '');
    const formattedPhone = formatPhoneNumber(value);

    // 기본 정규식 체크 (숫자와 하이픈만 허용)
    const phoneRegex = /^[0-9-]*$/;
    if (!phoneRegex.test(value)) {
        return { isValid: false, error: '올바른 연락처 형식이 아닙니다.' };
    }

    // 길이 체크
    if (formattedPhone.length >= 20) {
        return { isValid: false, error: '고객사 연락처는 최대 20자까지 입력 가능합니다.' };
    }

    if (formattedPhone.length < 8 && formattedPhone.length > 0) {
        return { isValid: false, error: '고객사 연락처는 최소 8자 이상 입력해야 합니다.' };
    }

    // 포맷팅이 제대로 되었는지 확인 (올바른 패턴인지 체크)
    const isProperlyFormatted = checkPhoneFormat(originalNumbers, formattedPhone);
    if (!isProperlyFormatted && originalNumbers.length > 0) {
        return { isValid: false, error: '올바른 연락처 형식을 입력해 주세요. (예: 02-1234-5678, 010-1234-5678, 1588-1234)' };
    }

    return { isValid: true, error: '' };
};

// 연락처 포맷이 올바른지 확인하는 함수
const checkPhoneFormat = (originalNumbers, formattedPhone) => {
    if (!originalNumbers || originalNumbers.length === 0) return false;

    // 포맷팅 후 하이픈이 추가되었는지 확인
    const hasHyphen = formattedPhone.includes('-');

    // 올바른 패턴들
    const validPatterns = [
        /^02-\d{3,4}-\d{4}$/,           // 02-XXX-XXXX 또는 02-XXXX-XXXX
        /^010-\d{3,4}-\d{4}$/,         // 010-XXX-XXXX 또는 010-XXXX-XXXX
        /^1[5-8]\d{2}-\d{4}$/,         // 1588-XXXX 등 고객센터 번호
        /^0[3-6]\d-\d{3,4}-\d{4}$/     // 031-XXX-XXXX 등 지역번호
    ];

    // 하이픈이 있으면서 올바른 패턴 중 하나와 일치하는지 확인
    if (hasHyphen && validPatterns.some(pattern => pattern.test(formattedPhone))) {
        return true;
    }

    // 하이픈이 없으면 유효하지 않음 (포맷팅이 안된 것)
    return false;
};

// 연락처 입력 핸들러 (통합 함수)
const handlePhoneChange = (value, formData, setFormData, setPhoneError, setIsInvalid) => {
    const formattedPhone = formatPhoneNumber(value);
    const validation = validatePhoneNumber(value);

    // 포맷된 전화번호로 폼 데이터 업데이트
    setFormData(prev => ({
        ...prev,
        clientPhone: formattedPhone
    }));

    // 유효성 검사 결과 설정
    if (setIsInvalid) {
        setIsInvalid(!validation.isValid);
    }

    if (setPhoneError) {
        setPhoneError(validation.error);
    }

    return { formattedPhone, validation };
};


// 날짜 포맷  '2024-12-18 14:59:00' 용 (통합 처리)
const formatDate = dateString => {
    if (!dateString) return '-';
    if (dateString === '-') return '-';

    // 이미 포맷된 문자열인지 확인 (YYYY-MM-DD HH:MM:SS 형태)
    if (typeof dateString === 'string' && dateString.match(/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/)) {
        return dateString; // 이미 포맷된 문자열이면 그대로 반환
    }

    // 타임스탬프인지 ISO 문자열인지 확인
    if (typeof dateString === 'number' || !isNaN(dateString)) {
        // 타임스탬프인 경우
        const date = new Date(Number(dateString));
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    } else {
        // ISO 문자열인 경우 (기존 로직 유지)
        const utcDate = new Date(dateString);
        const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);

        const year = localDate.getFullYear();
        const month = String(localDate.getMonth() + 1).padStart(2, '0');
        const day = String(localDate.getDate()).padStart(2, '0');
        const hours = String(localDate.getHours()).padStart(2, '0');
        const minutes = String(localDate.getMinutes()).padStart(2, '0');
        const seconds = String(localDate.getSeconds()).padStart(2, '0');

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    }
};
// 날짜 포맷  '2024-12-18 14:59:00' 용 (datepicker용용)
//s는 시작날짜용 00시 00분 00초 시작
//e는 끝날짜용 23시 59분 59초 끝
const formatDate_datepicker = (dateString, type = 's') => {
    if (!dateString) return '-';
    if (dateString === '-') return '-';

    const utcDate = new Date(dateString); // 서버에서 받은 UTC 시간
    const localDate = utcDate;

    const year = localDate.getFullYear();
    const month = String(localDate.getMonth() + 1).padStart(2, '0'); // 월은 0부터 시작하므로 +1
    const day = String(localDate.getDate()).padStart(2, '0');

    let hours = '00';
    let minutes = '00';
    let seconds = '00';

    if (type === 'e') {
        hours = '23';
        minutes = '59';
        seconds = '59';
    }

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // "YYYY-MM-DD HH:MM:SS"
};

// 날짜 포맷 (로그 검색용도) '2024-12-18 14:59:00' 용 (UTC제외)
const formatDate_log = (date) => {

    const [datePart, timePart] = date.split('T'); // 'T'를 기준으로 날짜와 시간을 분리
    const [year, month, day] = datePart.split('-'); // 날짜를 '-'로 분리
    const [hours, minutes, seconds] = timePart.split(':'); // 시간을 ':'로 분리

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`; // 원하는 포맷으로 조합
};

// toISOString 결과를 '2024-12-18T14:59:00' 형태로 변환하는 함수
const formatToCustomISO = date => {
    if (!date) return null; // 날짜가 없으면 null 반환

    // 사용자의 로컬 타임존을 고려
    const offset = date.getTimezoneOffset() * 60000;
    const utcDate = new Date(date.getTime() - offset);

    // API 호출 요청 형식으로
    return utcDate
        .toISOString()
        .replace('Z', '')
        .replace(/\.(\d{3})/, '');
};

// 부모페이지 보내기 용도, 메뉴 헤더에 주로 추가되어있음음
const goToParentPath = () => {
    const pathSegments = location.pathname.split('/');
    // 마지막 경로 세그먼트를 제거하고 재조합
    pathSegments.pop(); // 'bc' 제거
    return pathSegments.join('/') || '/'; // '/'로 리턴 (루트로 이동)
};

/**
 * 건수 출력 방식 1
 */
const formatCountStyle1 = (count) => {
    if (count >= 100000) {
        return (count / 1000).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + 'K';
    }
    return count.toLocaleString();
};

/**
 * 건수 출력 방식 2
 */
const formatCountStyle2 = (count) => {
    if (count >= 1000000) {
        return (count / 1000000).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + 'M';
    } else if (count >= 1000) {
        return (count / 1000).toLocaleString(undefined, { minimumFractionDigits: 1, maximumFractionDigits: 1 }) + 'K';
    }
    return count.toLocaleString();
};

/**
 * 용량 출력 방식
 */
const formatCountStyle3 = (sizeInBytes) => {
    if (sizeInBytes < 1024) {
        return `${sizeInBytes.toFixed(2)} B`;
    } else if (sizeInBytes < 1024 * 1024) {
        return `${(sizeInBytes / 1024).toFixed(2)} KB`;
    } else if (sizeInBytes < 1024 * 1024 * 1024) {
        return `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`;
    } else if (sizeInBytes < 1024 * 1024 * 1024 * 1024) {
        return `${(sizeInBytes / (1024 * 1024 * 1024)).toFixed(2)} GB`;
    } else {
        return `${(sizeInBytes / (1024 * 1024 * 1024 * 1024)).toFixed(2)} TB`;
    }
};


// 최종 수량 반영 방법 (rounding_mode) 라벨.
// 값: ceil (올림), round (반올림), floor (내림). null/미지정 시 '올림' (기본값).
const getRoundingModeLabel = (mode) => {
    const labels = { ceil: '올림', round: '반올림', floor: '내림' };
    return labels[mode] || '올림';
};

export {
    handleValueDelete,
    goToParentPath,
    formatDate,
    formatDate_datepicker,
    formatDate_log,
    formatCountStyle1,
    formatCountStyle2,
    formatCountStyle3,
    formatToCustomISO,
    formatPhoneNumber,
    validatePhoneNumber,
    handlePhoneChange,
    checkPhoneFormat,
    getRoundingModeLabel
}